import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

/**
 * Router guard that redirects to home if conversion cards feature flag is disabled
 * @param to - The route location object
 * @returns The redirect location object or undefined if no redirect is needed
 */
export const checkConversionCardsFeatureFlag: HermesGuardFn = async (to) => {
  // Only check for conversion cards routes
  const conversionCardsRoutes = ['brand.conversion-cards']

  if (typeof to.name !== 'string' || !conversionCardsRoutes.includes(to.name)) {
    return undefined
  }

  const featureFlags = useFeatureFlags()

  // Check feature flag
  if (!featureFlags.isEnabled('hermes.conversionCardsPage')) {
    return {
      name: 'brand.home',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
